/**
 * Handles moving the specific inline-table element around the page to show it inline
 * and also hiding it back into it's parent table group. It also updates the link text.
 *
 * @param {object} inlineTableGroup
 * @param {object} inlineTable
 * @param {object} event
 */
export default function(inlineTableGroup, inlineTable, event) {
  event.preventDefault();

  if (event.target.getAttribute('aria-selected') === 'true') {
    inlineTable.insertInGroup(inlineTableGroup);

    event.target.setAttribute('aria-selected', 'false');
    event.target.textContent = event.target.getAttribute('data-toggle-open-label');
    return;
  }

  // If the table is already being shown at another location, update the link selected property
  if (inlineTable.isAlreadyInline()) {
    inlineTable.setLinkToHidden();
  }

  inlineTable.insertInline(event.target);
  event.target.setAttribute('aria-selected', 'true');
  event.target.textContent = event.target.getAttribute('data-toggle-close-label');
}
